module.exports = __webpack_public_path__ + "resources/img/img_secure_center02_m_en.60a5b6277fd8f71ff06fdeab2ebe5b9a.png";